import React, { Component } from "react";
import FlexView from "react-flexview";
import SimpleDDL from "../../../../../../modules/SimpleDDL";
import { monthOptions, yearOptions } from "../../../config";
import SimpleButton from "../../../../../../modules/commons/SimpleButton";
import SimpleDataTable from "../../../../../../modules/SimpleDataTable";
import { buildExcelRequestBodyJobYTD, getTableConfig, mapJobYTDToTable } from "./config";
import moment from "moment";
import { fetchDataAsync } from "../../../../../../Services/Utils";
import Api from "../../../../../../Services/Api";
import { saveAs } from "file-saver";

export default class LaporanYTD extends Component {
  constructor(props) {
    super(props);
    this.currentYear = Number(moment().format("YYYY"));
    this.state = {
      year: yearOptions.find((item) => item.value === this.currentYear),
      tableConfig: getTableConfig(this.currentYear),
      dataTable: [],
    };
  }

  componentDidMount() {}

  handleChangeValue = (name, value) => {
    this.setState((prev) => ({
      ...prev,
      [name]: value,
      ...(name === "year" && {
        tableConfig: getTableConfig(value?.value),
      }),
    }));
  };

  fetchData = async () => {
    const { onTriggerLoading, search } = this.props;
    const { year } = this.state;

    if (!search) return;
    onTriggerLoading();

    const res = await fetchDataAsync({
      asyncFn: Api.create("NAGAMAS_REPORT_DTO").getLaporanJualJobYearToDate,
      menuName: "Dashboard Kabeng Keatas - Laporan Job YTD",
      args: {
        kodeCabang: search,
        year: year?.value,
      },
    });

    onTriggerLoading();
    if (res.ok && res.data.status === "S") {
      this.setState({
        dataTable: mapJobYTDToTable(res.data.data),
      });
    }
  };

  handleSearch = () => {
    this.fetchData();
  };

  handlePrint = async () => {
    const { year, dataTable } = this.state;
    const { onTriggerLoading } = this.props;
    onTriggerLoading();

    try {
      const reqBody = buildExcelRequestBodyJobYTD({
        year: year.value,
        dataTable,
      });

      const res = await fetchDataAsync({
        asyncFn: Api.create("NAGAMAS_REPORT").generateExcelFromPayload,
        menuName: "Dashboard Level Kabeng Keatas - Laporan Job YTD",
        setError: this.props.setError,
        args: reqBody,
      });

      if (res?.ok) {
        const blob = new Blob([res.data], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });

        saveAs(blob, `${reqBody.filename}.xlsx`);
      }
    } catch (error) {
      console.error("Error saat generate Excel:", error);
      this.props.setError("Gagal generate file Excel");
    } finally {
      onTriggerLoading();
    }
  };

  render() {
    const { year, dataTable, tableConfig } = this.state;
    return (
      <React.Fragment>
        <FlexView className="margin-top-15px" style={{ gap: "20px" }}>
          <SimpleDDL
            id="select_options_tahun"
            box="search"
            name="year"
            containerclassname="width width-150px"
            placeholder="Tahun"
            options={yearOptions}
            value={year}
            onChange={(value, { name }) => this.handleChangeValue(name, value)}
          />
          <SimpleButton
            id="btn_search"
            text="Cari"
            className="margin margin-top-5px"
            onClick={this.handleSearch}
          />
        </FlexView>
        <p className="margin-bottom-20px" style={{ fontWeight: "bold" }}>
          LAPORAN JOB YEAR TO DATE
        </p>
        <SimpleDataTable
          data={dataTable}
          columns={tableConfig}
          options={{ pagination: false }}
        />
        <FlexView hAlignContent="right" className="margin-top-20px">
          <SimpleButton id="btn_print" text="CETAK" onClick={() => this.handlePrint()} />
        </FlexView>
      </React.Fragment>
    );
  }
}
